import { Page } from '@revolut-internal/ui-kit'
import { useNavigate } from 'react-router-dom'
import { FC } from 'react'

import { getChatDebugAssistantRoute } from 'lib/router'
import { PermissionBoundary } from 'containers/PermissionBoundary'

import { AiProcessDebugContent } from './components'
import { ProcessDebugDetailsProvider } from './providers'

export const AiProcessDebug: FC = () => {
  const navigate = useNavigate()

  const handleBack = () => {
    navigate(getChatDebugAssistantRoute())
  }

  return (
    <Page variant="focused-wide">
      <Page.Header onBack={handleBack}>Chat debug</Page.Header>
      <Page.Main>
        <PermissionBoundary permissions={['debug.process_actions.view']}>
          <ProcessDebugDetailsProvider>
            <AiProcessDebugContent />
          </ProcessDebugDetailsProvider>
        </PermissionBoundary>
      </Page.Main>
    </Page>
  )
}
